module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout__drawer"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("Vue")]), _vm._v(" "), _c('nav', {
    staticClass: "mdl-navigation"
  }, [_vm._l((_vm.nav), function(item) {
    return _c('router-link', {
      staticClass: "mdl-navigation__link",
      attrs: {
        "to": {
          name: item.name
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.hideNav($event)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.locales), function(item) {
    return (_vm.locales) ? _c('a', {
      class: {
        'mdl-navigation__link': true, 'language-item-mobile': true, 'active': item.active
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setLocale(item.locale)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]) : _vm._e()
  })], 2), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout__drawer-button",
    attrs: {
      "aria-expanded": "false",
      "role": "button",
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("more_horiz")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a89714a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/UiNav.vue
// module id = 259
// module chunks = 2